import { expr } from '@codegrade/utils';
import { emptyVNode } from './vue';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const { ifExpr, caseExpr } = expr;
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function ifOrEmpty(cond, then) {
    if (cond) {
        return then();
    }
    return emptyVNode();
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function ifJustOrEmpty(maybe, then) {
    return maybe.caseOf({
        Just: then,
        Nothing: emptyVNode,
    });
}
